// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/campton/CamptonBook.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Campton";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "Campton";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.font-fontFamily {
  font-family: "Campton";
}

.fontSize-36 {
  font-size: 36px;
}

.fontSize-14 {
  font-size: 14px;
}

.fontSize-16 {
  font-size: 16px;
}

.fontSize-18 {
  font-size: 18px;
}

.fontSize-24 {
  font-size: 24px;
}

.fontSize-28 {
  font-size: 28px;
}

.fontSize-20 {
  font-size: 20px;
}

.margin-top-86 {
  margin-top: 86px;
}

.text-color-primary {
  color: #e75c25;
}

.box-radius-12 {
  border-radius: 12px;
}

.box-radius-16 {
  border-radius: 16px;
}

.font-fontFamily-inter {
  font-family: "Inter";
  font-weight: 500;
}

.font-hover-underline:hover {
  text-decoration: underline;
}

.margin-bottom-39 {
  margin-bottom: 39px;
}

.font-fontFamily-400 {
  font-family: "Campton";
  font-weight: 400;
}

.margin-top-45 {
  margin-top: 45px;
}

.color-black {
  color: black;
}

.font-weight-text {
  font-weight: 500;
}

.font-color-gray {
  color: #8E8E93;
}

.font-color-purple {
  color: #652B88;
}

.font-weight-500 {
  font-weight: 500;
}

.fc-toolbar-chunk:first-child button {
  background: #fcfcfc;
  border: 1px solid #f3f3f3;
  color: #686868;
  height: 25px;
  width: 139.1148071289px;
  border-radius: 12px;
}
.fc-toolbar-chunk:first-child button .btn.btn-primary:active {
  background-color: blue;
}

.fc-toolbar-chunk:last-child button {
  background-color: transparent;
  border: none;
  color: #b1b1b1;
}

.appointment-heading-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}
.appointment-heading-div h4 {
  font-weight: 500;
}
.appointment-heading-div h1 {
  font-family: "Campton";
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #000000;
}

.appointments-toggle-page-icons-div {
  height: 40px;
  width: 79px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  border: 1px solid #d8d8dc;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px;
}

.calender-event-container .calender-total-appointments {
  font-family: "Campton";
  font-style: normal;
  font-weight: 400;
  color: #3e3e3e;
}
.calender-event-container .calender-appointment-timings {
  font-family: "Campton";
  color: #ef7e54;
}

.fc-toolbar-chunk:first-child button.fc-button-active {
  color: var(--fc-header-active-color);
  background-color: transparent;
  border-color: transparent;
}

.fc-day-today {
  background-color: #e89f23 !important;
}

.calender-appointment-timings-div {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.appointment-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.appointment-header-container .today-appointment-heading {
  font-family: "proxima";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #000000;
}
.appointment-header-container .all-apointment-link-div {
  font-family: "Campton";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: right;
  text-decoration-line: underline;
  color: #e75c25;
  cursor: pointer;
  margin-bottom: 30px;
  gap: 5px;
}

.fc-toolbar-chunk .btn-primary {
  --bs-btn-bg: transparent;
  --bs-btn-color: #e75c25;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-color: #e75c25;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-color: #e75c25;
  --bs-btn-active-border-color: transparent;
  font-size: 14px;
  font-weight: 500;
}

.fc-toolbar-chunk .btn-primary:focus {
  background-color: #e89f23; /* Change to the desired color */
  color: #ffffff; /* Change to the desired text color */
}

div.fc-toolbar-chunk {
  width: 550px;
  display: flex;
  align-items: center;
  gap: "10px";
}

button.fc-customButton-button.btn.btn-primary {
  font-size: 18px;
  font-family: "Campton";
  color: #e75c25;
  width: 489px;
}

div.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 1040px) {
  div.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
    flex-wrap: wrap;
  }
}
h2#fc-dom-1.fc-toolbar-title {
  width: 340px;
  font-family: "Campton";
}

.fc .fc-daygrid-day-number {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom/components/_calender.scss","webpack://./src/assets/scss/custom/pages/_dashboard.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4CAAA;AACF;ACHA;EACE,sBAAA;EACA,4CAAA;ADKF;ACFA;EACE,sBAAA;ADIF;;ACDA;EACE,eAAA;ADIF;;ACFA;EACE,eAAA;ADKF;;ACHA;EACE,eAAA;ADMF;;ACJA;EACE,eAAA;ADOF;;ACLA;EACE,eAAA;ADQF;;ACNA;EACE,eAAA;ADSF;;ACPA;EACE,eAAA;ADUF;;ACRA;EACE,gBAAA;ADWF;;ACTA;EACE,cAAA;ADYF;;ACVA;EACE,mBAAA;ADaF;;ACXA;EACE,mBAAA;ADcF;;ACZA;EACE,oBAAA;EACA,gBAAA;ADeF;;ACbA;EACA,0BAAA;ADgBA;;ACdA;EACE,mBAAA;ADiBF;;ACfA;EACE,sBAAA;EACA,gBAAA;ADkBF;;AChBA;EACE,gBAAA;ADmBF;;ACjBA;EACE,YAAA;ADoBF;;AClBA;EACE,gBAAA;ADqBF;;ACnBA;EACE,cAAA;ADsBF;;ACpBA;EACE,cAAA;ADuBF;;ACrBA;EACE,gBAAA;ADwBF;;AA3FA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA8FF;AA7FE;EACE,sBAAA;AA+FJ;;AA3FA;EACE,6BAAA;EACA,YAAA;EACA,cAAA;AA8FF;;AAvFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA0FF;AAzFE;EACE,gBAAA;AA2FJ;AAzFE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AA2FJ;;AAxFA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AA2FF;;AAvFE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA0FJ;AAxFE;EACE,sBAAA;EACA,cAAA;AA0FJ;;AAtFA;EACE,oCAAA;EACA,6BAAA;EACA,yBAAA;AAyFF;;AAhFA;EACE,oCAAA;AAmFF;;AAhFA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;AAmFF;;AAhFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAmFF;AAlFE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAoFJ;AAlFE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAoFJ;;AAhFE;EACE,wBAAA;EACA,uBAAA;EACA,kCAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;AAmFJ;;AA/EA;EACE,yBAAA,EAAA,gCAAA;EACA,cAAA,EAAA,qCAAA;AAkFF;;AAhFA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAmFF;;AAjFA;EACE,eAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAoFF;;AAlFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAqFF;;AAjFA;EACE;IACE,eAAA;EAoFF;AACF;AAvEA;EACE,YAAA;EACA,sBAAA;AAyEF;;AAvEA;EACE,eAAA;AA0EF","sourcesContent":["@font-face {\n  font-family: \"Campton\";\n  src: url(\"../../../fonts/campton/CamptonBook.otf\");\n}\n@import \"../../../scss/custom/pages/dashboard\";\n.fc-toolbar-chunk:first-child button {\n  background: #fcfcfc;\n  border: 1px solid #f3f3f3;\n  color: #686868;\n  height: 25px;\n  width: 139.11480712890625px;\n  border-radius: 12px;\n  .btn.btn-primary:active {\n    background-color: blue;\n  }\n}\n\n.fc-toolbar-chunk:last-child button {\n  background-color: transparent;\n  border: none;\n  color: #b1b1b1;\n}\n\n// .appointment-heading-div{\n\n// }\n\n.appointment-heading-div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 40px;\n  h4 {\n    font-weight: 500;\n  }\n  h1 {\n    font-family: \"Campton\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 36px;\n    line-height: 30px;\n    display: flex;\n    align-items: center;\n    color: #000000;\n  }\n}\n.appointments-toggle-page-icons-div {\n  height: 40px;\n  width: 79px;\n  left: 0px;\n  top: 0px;\n  border-radius: 8px;\n  border: 1px solid #d8d8dc;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 5px;\n}\n\n.calender-event-container {\n  .calender-total-appointments {\n    font-family: \"Campton\";\n    font-style: normal;\n    font-weight: 400;\n    color: #3e3e3e;\n  }\n  .calender-appointment-timings {\n    font-family: \"Campton\";\n    color: #ef7e54;\n  }\n}\n\n.fc-toolbar-chunk:first-child button.fc-button-active {\n  color: var(--fc-header-active-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n\n// .fc-event {\n//   position: relative !important;\n//   top: 100% !important;\n//   transform: translateY(150%);\n// }\n\n.fc-day-today {\n  background-color: #e89f23 !important;\n}\n\n.calender-appointment-timings-div {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.appointment-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .today-appointment-heading {\n    font-family: \"proxima\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    display: flex;\n    align-items: center;\n    color: #000000;\n  }\n  .all-apointment-link-div {\n    font-family: \"Campton\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    text-align: right;\n    text-decoration-line: underline;\n    color: #e75c25;\n    cursor: pointer;\n    margin-bottom: 30px;\n    gap: 5px;\n  }\n}\n.fc-toolbar-chunk {\n  .btn-primary {\n    --bs-btn-bg: transparent;\n    --bs-btn-color: #e75c25;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-bg: transparent;\n    --bs-btn-hover-color: #e75c25;\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-bg: transparent;\n    --bs-btn-active-color: #e75c25;\n    --bs-btn-active-border-color: transparent;\n    font-size: 14px;\n    font-weight: 500;\n  }\n}\n\n.fc-toolbar-chunk .btn-primary:focus {\n  background-color: #e89f23; /* Change to the desired color */\n  color: #ffffff; /* Change to the desired text color */\n}\ndiv.fc-toolbar-chunk {\n  width: 550px;\n  display: flex;\n  align-items: center;\n  gap:\"10px\"\n}\nbutton.fc-customButton-button.btn.btn-primary {\n  font-size: 18px;\n  font-family: \"Campton\";\n  color: #e75c25;\n  width: 489px;\n}\ndiv.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  // flex-wrap: wrap;\n}\n\n@media (max-width:1040px) {\n  div.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr{\n    flex-wrap: wrap;\n  }\n}\n// .fc .fc-toolbar {\n//   display: flex;\n//   flex-wrap: wrap;\n//   align-items: center;\n//   justify-content: space-between;\n//   gap: 125px;\n// }\n\n// button.fc-dayGridDay-button.btn.btn-primary{\n\n// }\nh2#fc-dom-1.fc-toolbar-title{\n  width: 340px;\n  font-family: 'Campton';\n}\n.fc .fc-daygrid-day-number{\n  font-size: 15px;\n}","@font-face {\n  font-family: \"Campton\";\n  src: url(\"../../../fonts/campton/CamptonBook.otf\");\n}\n\n.font-fontFamily {\n  font-family: \"Campton\";\n  // font-weight: 500;\n}\n.fontSize-36 {\n  font-size: 36px;\n}\n.fontSize-14 {\n  font-size: 14px;\n}\n.fontSize-16 {\n  font-size: 16px;\n}\n.fontSize-18 {\n  font-size: 18px;\n}\n.fontSize-24 {\n  font-size: 24px;\n}\n.fontSize-28 {\n  font-size: 28px;\n}\n.fontSize-20 {\n  font-size: 20px;\n}\n.margin-top-86 {\n  margin-top: 86px;\n}\n.text-color-primary {\n  color: #e75c25;\n}\n.box-radius-12 {\n  border-radius: 12px;\n}\n.box-radius-16 {\n  border-radius: 16px;\n}\n.font-fontFamily-inter {\n  font-family: \"Inter\";\n  font-weight: 500;\n}\n.font-hover-underline:hover{\ntext-decoration: underline;\n}\n.margin-bottom-39{\n  margin-bottom: 39px;\n}\n.font-fontFamily-400 {\n  font-family: \"Campton\";\n  font-weight: 400;\n}\n.margin-top-45 {\n  margin-top: 45px;\n}\n.color-black{\n  color:black\n}\n.font-weight-text{\n  font-weight: 500;\n}\n.font-color-gray{\n  color:#8E8E93\n}\n.font-color-purple{\n  color:#652B88\n}\n.font-weight-500{\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
